import { render, staticRenderFns } from "./TaxSetupOrderAndTest.vue?vue&type=template&id=424ce060&scoped=true&"
import script from "./TaxSetupOrderAndTest.vue?vue&type=script&lang=js&"
export * from "./TaxSetupOrderAndTest.vue?vue&type=script&lang=js&"
import style0 from "./TaxSetupOrderAndTest.vue?vue&type=style&index=0&id=424ce060&lang=scss&scoped=true&"
import style1 from "./TaxSetupOrderAndTest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ce060",
  null
  
)

export default component.exports